import React, { useState } from "react";
import "../styles/referralApply.css";

export default function ReferralApplyScreen() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    type: "manager",
    city: "",
    estimatedLocations: "",
    notes: ""
  });

  const [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const API_BASE =
        process.env.REACT_APP_API_URL || "https://pay2pee.onrender.com";

      const res = await fetch(`${API_BASE}/api/referrals/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Failed to submit application");
      }

      setSubmitted(true);
    } catch (err) {
      console.error("Referral application submit failed:", err);
      alert(err.message || "Failed to submit application");
    }
  }

  if (submitted) {
    return (
      <div className="applySuccess">
        <h2>You're in 🎉</h2>
        <p>We’ll review your application and follow up shortly.</p>
      </div>
    );
  }

  return (
    <div className="applyContainer">
      <div className="applyCard">
        <h1 className="applyTitle">Apply to the Pay2Pee Referral Program</h1>
        <p className="applySubtitle">
          Earn from locations you bring onto the platform.
        </p>

        <form className="applyForm" onSubmit={handleSubmit}>
          <input
            className="applyInput"
            name="name"
            placeholder="Full Name"
            onChange={handleChange}
            required
          />

          <input
            className="applyInput"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
          />

          <input
            className="applyInput"
            name="phone"
            placeholder="Phone"
            onChange={handleChange}
            required
          />

          <select className="applySelect" name="type" onChange={handleChange}>
            <option value="manager">Manager</option>
            <option value="influencer">Influencer</option>
            <option value="other">Other</option>
          </select>

          <input
            className="applyInput"
            name="city"
            placeholder="City"
            onChange={handleChange}
          />

          <input
            className="applyInput"
            name="estimatedLocations"
            placeholder="How many locations can you refer?"
            onChange={handleChange}
          />

          <textarea
            className="applyTextarea"
            name="notes"
            placeholder="Anything we should know?"
            onChange={handleChange}
          />

          <button className="applyButton" type="submit">
            Apply Now
          </button>
        </form>
      </div>
    </div>
  );
}